import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useSectionNav } from "./Nav";
import { usePhone } from "../../lib/content";

export function Footer({ minimal = false }) {
  const go = useSectionNav();
  const phone = usePhone();
  const year = new Date().getFullYear();
  const sections = [["Home", "top"], ["Our Process", "process"], ["Results", "results"], ["Pricing", "pricing"]];
  return (
    <footer className="relative border-t border-white/[0.07] bg-ink" data-testid="site-footer">
      <div className="container-x grid gap-12 py-16 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo testId="footer-logo-link" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Fully done-for-you Facebook & Instagram advertising for service-based businesses.
          </p>
          <p className="mt-6 text-sm text-slate-300">Billings, Montana</p>
          <a href={`tel:${phone.tel}`} data-testid="footer-phone-link" className="mt-1 inline-block text-sm text-white underline-offset-4 hover:underline">
            Phone: {phone.display}
          </a>
        </div>
        {!minimal && (
          <nav aria-label="Footer">
            <p className="eyebrow mb-4">Site</p>
            <ul className="space-y-2.5 text-sm">
              {sections.map(([l, id]) => (
                <li key={id}><button data-testid={`footer-${id}-link`} onClick={() => go(id)} className="text-slate-300 hover:text-white">{l}</button></li>
              ))}
              <li><Link to="/get-started" data-testid="footer-get-started-link" className="text-slate-300 hover:text-white">Get Started</Link></li>
            </ul>
          </nav>
        )}
        <nav aria-label="Legal">
          <p className="eyebrow mb-4">Company</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-slate-300 hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link" className="text-slate-300 hover:text-white">Terms of Service</Link></li>
            <li><a href={`tel:${phone.tel}`} data-testid="footer-contact-link" className="text-slate-300 hover:text-white">Contact — call or text</a></li>
          </ul>
        </nav>
      </div>
      <div className="container-x flex flex-col gap-2 border-t border-white/[0.06] py-6 text-xs text-slate-400 sm:flex-row sm:justify-between">
        <p>© {year} Rivanta Labs. All rights reserved.</p>
        <p>Individual results vary. Advertising spend is separate from agency fees.</p>
      </div>
    </footer>
  );
}
